import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type DocType = 'process' | 'ksa' | 'dca'

export interface RelatedDoc {
  id: string
  name: string
  doc_type: DocType
  description?: string
}

export interface DocumentResponse {
  node_id: string
  name: string
  doc_type: DocType
  content?: string | null
  description?: string | null
  summary?: string | null
  related_docs?: RelatedDoc[]
  error?: string
}

interface DocumentState {
  activeNodeId: string | null
  activeDocType: DocType | null
  content: string | null
  name: string | null
  loading: boolean
  error: string | null
  relatedDocs: RelatedDoc[]
}

const initialState: DocumentState = {
  activeNodeId: null,
  activeDocType: null,
  content: null,
  name: null,
  loading: false,
  error: null,
  relatedDocs: [],
}

const documentSlice = createSlice({
  name: 'document',
  initialState,
  reducers: {
    setActiveDocument(state, action: PayloadAction<{ nodeId: string; docType: DocType }>) {
      state.activeNodeId = action.payload.nodeId
      state.activeDocType = action.payload.docType
      state.content = null
      state.name = null
      state.loading = true
      state.error = null
      state.relatedDocs = []
    },
    setDocumentContent(state, action: PayloadAction<{ content: string | null; name: string | null; relatedDocs?: RelatedDoc[] }>) {
      state.content = action.payload.content
      state.name = action.payload.name
      state.relatedDocs = action.payload.relatedDocs || []
      state.loading = false
    },
    setDocumentError(state, action: PayloadAction<string>) {
      state.error = action.payload
      state.loading = false
    },
    clearDocument(state) {
      state.activeNodeId = null
      state.activeDocType = null
      state.content = null
      state.name = null
      state.loading = false
      state.error = null
      state.relatedDocs = []
    },
  },
})

export const { setActiveDocument, setDocumentContent, setDocumentError, clearDocument } = documentSlice.actions
export default documentSlice.reducer
